jQuery(document).ready(function($) {
  $('#oxg-login-form').on('submit', function(e) {
    e.preventDefault();
    console.log('click')
    var user = $('#user').val();
    var password = $('#password').val();
    var redirect = $('#redirect').val();
    console.log(user, password, redirect)
    console.log(ajax_obj.ajax_url)
    console.log(ajax_obj.security)
    $.ajax({
      url: ajax_obj.ajax_url, // URL
      type: 'POST',
      data: {
        action: 'oxg_login', // Hook
        user: user,
        password: password,
        redirect: redirect,
        security: ajax_obj.security // Nonce
      },
      success: function(response) {
        console.log(response)
        $('#user-feedback').removeClass('is-hidden style-danger style-success blink').addClass(response.data.message_style + ' flash');
        $('#user-feedback-text').text(response.data.message);
        if(response.data.loggedin == true) {
          setTimeout(()=> {
            let redirect_url = response.data.redirect_url;
            if (redirect_url.endsWith('/dashboard/') || redirect_url.endsWith('/dashboard') || redirect_url == window.location.origin) {
              redirect_url += '?hl_planning_card=1' //Show highlight animations on dashboard if user just logged in
            }
            window.location.href = redirect_url;
          }, 250);
        }
      },
      error: function(xhr, status, error) { 
        console.error('Error', error)
      }
    });
  });
});
